import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import ModeEditOutlinedIcon from "@mui/icons-material/ModeEditOutlined";
import {
  Box,
  Grid,
  Modal,
  TableCell,
  TableRow,
  Typography,
  tableCellClasses,
} from "@mui/material";
import React, { useState } from "react";
import { useMutation } from "react-query";
import styled from "styled-components";
import { v4 as uuid } from "uuid";
import { GETReports } from "../../../models/pBIReport.model";
import { DeletePbiReport } from "../../../services/pBIReport.service";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(even)": {
    backgroundColor: "#F9FAFC",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
const deactiveUserStyle = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",

  minWidth: {
    xs: 250,
    sm: 300,
    md: 400,
    lg: "400px",
  },
  maxHeight: "70vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  overflow: "auto",
  overflowX: "hidden",
  paddingRight: "3vh",
  paddingTop: "3vh",
  // direction: "ltr",
  "&::-webkit-scrollbar": {
    width: 7,
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "#F9FAFC",
    border: "2px solid #DAE0E4",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "#9AAFC4",
  },
};

interface Props {
  reports: GETReports;
  setUpdateReports: (updateReports: string) => void;
  setSubReport: (state: GETReports) => void;
  setOpenAddSubReportModal: (state: boolean) => void;
  setAddOrEdit: (state: "Add" | "Edit") => void;
}

const ReportAccardionTableRows = ({
  reports,
  setUpdateReports,
  setSubReport,
  setOpenAddSubReportModal,
  setAddOrEdit,
}: Props) => {
  const [openDeleteModal, setOpenDeleteModal] = useState(false);

  const { mutate: DeletePbiReportMutate } = useMutation(DeletePbiReport, {
    onSuccess: (data: boolean) => {
      if (data) {
        setUpdateReports(uuid());
      }
    },
    onError: () => {},
  });

  return (
    <>
      <StyledTableRow>
        <StyledTableCell align="center" component="th" scope="row">
          <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>
            {reports.title}
          </p>
        </StyledTableCell>
        <StyledTableCell align="center" component="th" scope="row">
          <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>
            {reports.pbiReportTypeTitle}
          </p>
        </StyledTableCell>
        <StyledTableCell align="center" component="th" scope="row">
          <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>
            {reports.permissionTitle}
          </p>
        </StyledTableCell>
        <StyledTableCell align="center" component="th" scope="row">
          <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>
            {reports.creationDatePersian}
          </p>
        </StyledTableCell>
        <StyledTableCell align="center" component="th" scope="row">
          <p style={{ textAlign: "center", marginBottom: "-.5vh" }}>
            {reports.creatorPersonFullName}
          </p>
        </StyledTableCell>

        <StyledTableCell align="center" sx={{ borderTop: "none !important" }}>
          <div
            style={{
              marginBottom: "-.5vh",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <ModeEditOutlinedIcon
              onClick={() => {
                setSubReport(reports);
                setOpenAddSubReportModal(true);
                setAddOrEdit("Edit");
              }}
              style={{
                color: "#1D4A87",
                cursor: "pointer",
                marginInline: "3px",
              }}
            />
            <DeleteOutlineIcon
              onClick={() => setOpenDeleteModal(true)}
              style={{
                color: "#1D4A87",
                cursor: "pointer",
                marginInline: "3px",
              }}
            />
          </div>
        </StyledTableCell>
      </StyledTableRow>
      {/* delete modal */}
      <div>
        <Modal
          open={openDeleteModal}
          onClose={() => setOpenDeleteModal(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={deactiveUserStyle}>
            <Typography
              component={"p"}
              display={"block"}
              textAlign={"center"}
              fontWeight={"bold"}
              marginY={"3rem"}
              fontSize={"14px"}
            >
              آیا از حذف کردن{" "}
              <span style={{ color: "#E6123D" }}>"{reports.title}"</span>{" "}
              اطمینان دارید؟
            </Typography>
            <Grid container justifyContent={"center"} gap={"1rem"}>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={6}
                sx={{
                  backgroundColor: "#E6123D",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
                padding={"0.5rem"}
                maxWidth={"150px !important"}
              >
                <Typography
                  textAlign={"center"}
                  color={"#FFF"}
                  fontWeight={"bold"}
                  // onClick={handleDel}
                  onClick={() => {
                    DeletePbiReportMutate({
                      pbiReportId: reports.id,
                    });
                  }}
                >
                  بله
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                sm={12}
                md={12}
                lg={6}
                sx={{
                  backgroundColor: "#607D8B",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
                padding={"0.5rem"}
                maxWidth={"150px !important"}
              >
                <Typography
                  textAlign={"center"}
                  color={"#FFF"}
                  fontWeight={"bold"}
                  onClick={() => setOpenDeleteModal(false)}
                >
                  خیر
                </Typography>
              </Grid>
            </Grid>
          </Box>
        </Modal>
      </div>
    </>
  );
};

export default ReportAccardionTableRows;
